<template>
  <div>
    <v-dialog
      v-if="drawer.searchDialog && isSearch"
      v-model="drawer.searchDialog"
      :transition="false"
      :max-width="mobileBreakpoints() ? '70%' : 340"
      dark
    >
      <v-card class="pa-0">
        <v-tabs
          v-show="activeCustomerLayers.length > 0"
          v-model="searchTab"
          height="32px"
          background-color="RMprimary"
          color="RMwhite"
          grow
        >
          <v-tab
            key="Location"
            style="font-size: 12px;"
          >
            {{ $t('Sidebar.search').split(' ')[1] }}
          </v-tab>
          <v-tab
            key="CustomLayer"
            style="font-size: 12px;"
          >
            {{ $t('NavigationSideBar.layer') }}
          </v-tab>
        </v-tabs>

        <v-card-text class="pa-2">
          <v-tabs-items
            v-model="searchTab"
            dark
          >
            <v-tab-item key="Location">
              <v-autocomplete
                v-if="!isLonLat"
                v-model="searchedLocation"
                solo
                dense
                clearable
                hide-details
                light
                :placeholder="$t('Sidebar.search')+'...'"
                :items="items"
                item-text="description"
                item-value="description"
                :search-input.sync="searchInput"
                :no-data-text="''"
                hide-no-data
                :menu-props="{ maxHeight: items.length ? '300px' : '0px', minWidth: '324px', maxWidth: '324px', offsetY: true }"
                prepend-inner-icon="mdi-magnify"
                append-icon=""
                @update:search-input="onSearchInput"
                @change="onSelectLocation"
              />
              <div
                v-else
                class="d-flex"
              >
                <v-text-field
                  v-model="latitude"
                  solo
                  dense
                  clearable
                  hide-details
                  light
                  :label="$t('Sidebar.lat')"
                />
                <v-text-field
                  v-model="longitude"
                  solo
                  dense
                  clearable
                  hide-details
                  class="ml-2"
                  light
                  :label="$t('Sidebar.lon')"
                />
              </div>
              <v-btn
                color="green"
                dark
                block
                class="mt-2"
                @click="moveToCoordinates()"
              >
                {{ $t('Sidebar.search').split(' ')[0] }}
              </v-btn>
              <v-divider
                class="my-3"
                color="white"
              />
              <v-btn
                color="green darken-1"
                text
                block
                @click="isLonLat=!isLonLat"
              >
                <div v-if="!isLonLat">
                  {{ $t('Sidebar.exactCoordinates') }}
                  <v-icon small>
                    mdi-map-marker
                  </v-icon>
                </div>
                <div v-else>
                  {{ $t('Sidebar.notExactCoordinates') }}
                  <v-icon small>
                    mdi-magnify
                  </v-icon>
                </div>
              </v-btn>
            </v-tab-item>
            <v-tab-item key="CustomLayer">
              <v-select
                ref="selectCustomerLayer"
                v-model="selectedCustomerLayer"
                :items="activeCustomerLayers"
                item-text="values_.layer_name"
                return-object
                :placeholder="$t('Select.value').split(' ')[0] + ' ' + $t('NavigationSideBar.layer').toLowerCase()"
                solo
                light
                dense
                :hide-details="isSelectVoid(selectedCustomerLayer) || customerLayerProperties.length > 0"
                :error-messages="!isSelectVoid(selectedCustomerLayer) && customerLayerProperties.length <= 0 ? $t('Select.layer.noProperties') : ''"
                :append-icon="isSelectVoid(selectedCustomerLayer) ? 'mdi-menu-down' : 'mdi-close'"
                @change="getCustomerLayerProperties()"
                @click:append="handleAppendIconClick(selectedCustomerLayer, 'selectCustomerLayer')"
              />
              <v-autocomplete
                v-if="customerLayerProperties.length > 0"
                ref="selectProperty"
                v-model="selectedCustomerLayerProperty"
                :items="customerLayerProperties"
                :placeholder="$t('Select.property')"
                solo
                light
                dense
                class="mt-2"
                :hide-details="isSelectVoid(selectedCustomerLayerProperty) || customerLayerPropertyValues.length > 0"
                :error-messages="!isSelectVoid(selectedCustomerLayerProperty) && customerLayerPropertyValues.length <= 0 ? $t('Select.property.noValues') : ''"
                :append-icon="isSelectVoid(selectedCustomerLayerProperty) ? 'mdi-menu-down' : 'mdi-close'"
                @change="getCustomerLayerPropertyValues()"
                @click:append="handleAppendIconClick(selectedCustomerLayerProperty, 'selectProperty')"
              />
              <v-autocomplete
                v-if="customerLayerPropertyValues.length > 0"
                ref="selectValue"
                v-model="selectedCustomerLayerPropertyValue"
                :items="customerLayerPropertyValues"
                :placeholder="$t('Select.value')"
                solo
                light
                dense
                hide-details
                class="mt-2"
                :append-icon="isSelectVoid(selectedCustomerLayerPropertyValue) ? 'mdi-menu-down' : 'mdi-close'"
                @change="findAllFeatures()"
                @click:append="handleAppendIconClick(selectedCustomerLayerPropertyValue, 'selectValue')"
              />
              <v-divider
                v-if="!isSelectVoid(selectedCustomerLayerPropertyValue)"
                class="my-3"
                color="white"
              />
              <div
                v-if="!isSelectVoid(selectedCustomerLayerPropertyValue) && findedFeatures.length > 0"
                class="d-flex align-center justify-space-between"
              >
                <v-btn
                  dark
                  icon
                  :disabled="findedFeatures.length <= 1"
                  @click="prevFeature()"
                >
                  <v-icon>
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <span>{{ selectedFeatureIndex + 1 }} / {{ findedFeatures.length }}</span>
                <v-btn
                  dark
                  icon
                  :disabled="findedFeatures.length <= 1"
                  @click="nextFeature()"
                >
                  <v-icon>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-else
      v-model="drawer.globalLayersDialog"
      :transition="false"
      :max-width="mobileBreakpoints() ? '70%' : 340"
      class="my-2"
      dark
    >
      <global-layer />
    </v-dialog>
  </div>
</template>

<script>
/* global google */
import { mapActions, mapState } from 'vuex';
import { fromLonLat } from 'ol/proj';
import { Fill, Circle, Stroke, Style } from 'ol/style';
import { getFormattedDate, getFeaturePosition } from '@/utils.js';

export default {
  components: {
    GlobalLayer: () => import('@/components/layout/GlobalLayer')
  },
  props: {
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      is4326: true,
      autocomplete: null,
      isLonLat: false,
      latitude: '',
      longitude: '',
      searchedPlace: '',
      searchedLocation: '',
      searchInput: '',
      searchTab: 'Location',
      selectedFeatureIndex: 0,
      items: [],
      findedFeatures: [],
      customerLayerProperties: [],
      customerLayerPropertyValues: [],
      selectedCustomerLayer: {},
      selectedCustomerLayerProperty: {},
      selectedCustomerLayerPropertyValue: {},
      selectedHighlightedFeature: null,
      placesServiceEl: null
    };
  },
  computed: {
    ...mapState(['drawer', 'map', 'app_user']),
    activeCustomerLayers() {
      return this.map.OLmap.getLayers().getArray().filter(layer => layer.get('layer_type') === 'CUSTOMER LAYER');
    }
  },
  watch: {
    $route() {}
  },
  mounted() {
    if (this.map?.OLmap) {
      this.map.OLmap.on('click', this.handleMapClick);
    }
  },
  beforeDestroy() {
    if (this.map?.OLmap) {
      this.map.OLmap.un('click', this.handleMapClick);
    }
  },
  methods: {
    ...mapActions(['newMapCenter', 'setRasterMarkerValue', 'setCoordinates']),
    isLandscape() {
      return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight < window.innerWidth;
    },
    mobileBreakpoints() {
      return /Mobi|Android/i.test(navigator.userAgent) || this.isLandscape();
    },
    async moveToCoordinates() {
      await this.onSelectLocation(this.searchedLocation);

      if (this.isLonLat && this.longitude !== '' && this.latitude !== '') {
        this.drawer.searchDialog = !this.drawer.searchDialog;
        // if (this.is4326) {
        this.newMapCenter(fromLonLat([this.longitude, this.latitude], 'EPSG:3857'));
        // } else {
        //   this.newMapCenter([this.longitude, this.latitude]);
        // }
      } else {
        if (!this.isLonLat && this.searchedLocation) {
          this.drawer.searchDialog = !this.drawer.searchDialog;
          this.newMapCenter(fromLonLat([this.map.longitude, this.map.latitude], 'EPSG:3857'));
        }
      }

      this.setRasterMarkerValue();
      this.$gtag.event('Località ricercata', {
        event_category: `${this.$route.params.id == undefined ? 'Home' : this.$route.params.id}`,
        event_label: `${Date.now()} - ${this.app_user.username} - ${this.app_user.crm_id} - ${getFormattedDate(new Date(), true, true)}`,
        value: `${this.searchedPlace} - Lat ${this.map.coordsLonLat[1]} - Lon ${this.map.coordsLonLat[0]}`
      });
    },
    onSearchInput (value) {
      this.searchInput = value;

      if (!value || value.length < 2) {
        this.items = [];

        return;
      }

      this.fetchPredictions(value);
    },
    fetchPredictions (input) {
      if (!window.google || !google.maps || !google.maps.places) {

        return;
      }

      const service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input, types: ['geocode'] }, (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
          this.items = [];

          return;
        }

        this.items = predictions;
      });
    },
    async onSelectLocation (value) {
      if (!value) {

        return;
      }

      this.searchedLocation = value;
      const item = this.items.find(i => i.description === value);

      if (!item || !item.place_id) {
        // fallback: se l'utente ha scritto un testo libero
        this.searchedPlace = value;

        return;
      }

      this.getPlaceDetails(item.place_id);
    },
    getPlaceDetails (placeId) {
      if (!window.google || !google.maps || !google.maps.places) {

        return;
      }

      if (!this.placesServiceEl) {
        this.placesServiceEl = document.createElement('div');
      }

      const service = new google.maps.places.PlacesService(this.placesServiceEl);
      service.getDetails({ placeId, fields: ['geometry', 'formatted_address', 'address_components'] }, (place, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !place || !place.geometry) {
          return;
        }

        this.setCoordinates({
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        });
      });
    },
    getCustomerLayerProperties() {
      const features = this.selectedCustomerLayer.getSource().getFeatures();
      const propertiesSet = new Set();

      features.forEach(feature => {
        const props = feature.getProperties();

        Object.keys(props).forEach(key => {
          if (key !== 'geometry') {
            propertiesSet.add(key);
          }
        });
      });

      this.customerLayerProperties = Array.from(propertiesSet);
      this.selectedCustomerLayerProperty = {};
      this.selectedCustomerLayerPropertyValue = {};
    },
    getCustomerLayerPropertyValues() {
      const features = this.selectedCustomerLayer.getSource().getFeatures();
      const valuesSet = new Set();

      features.forEach(feature => {
        const props = feature.getProperties();
        const position = getFeaturePosition(feature);
        const filterValidPositionFeature = !isNaN(position[0]) && !isNaN(position[1]);

        if (props[this.selectedCustomerLayerProperty] && filterValidPositionFeature) {
          valuesSet.add(props[this.selectedCustomerLayerProperty]);
        }
      });

      this.customerLayerPropertyValues = Array.from(valuesSet);
      this.selectedCustomerLayerPropertyValue = {};
    },
    isSelectVoid(variable) {
      if (typeof variable === 'number') {
        return isNaN(variable);
      }

      return Object.keys(variable).length === 0;
    },
    handleAppendIconClick(variable, ref) {
      if (this.isSelectVoid(variable)) {
        this.$refs[ref].isMenuActive = true;
      } else {
        switch (ref) {
          case 'selectCustomerLayer':
            this.selectedCustomerLayer = {};
            this.selectedCustomerLayerProperty = {};
            this.customerLayerProperties = [];
            this.selectedCustomerLayerPropertyValue = {};
            this.customerLayerPropertyValues = [];
            this.clearSelectedFeatureHighlight();
            break;
          case 'selectProperty':
            this.selectedCustomerLayerProperty = {};
            this.selectedCustomerLayerPropertyValue = {};
            this.customerLayerPropertyValues = [];
            this.clearSelectedFeatureHighlight();
            break;
          case 'selectValue':
            this.selectedCustomerLayerPropertyValue = {};
            break;
          default:
            break;
        }
      }
    },
    clearSelectedFeatureHighlight() {
      if (this.selectedHighlightedFeature) {
        this.selectedHighlightedFeature.setStyle(undefined);
        this.selectedHighlightedFeature = null;
      }

      if (this.map?.globalLayerPopup && this.map.globalLayerPopup.getElement()) {
        this.map.globalLayerPopup.getElement().style.display = 'none';
        this.map.globalLayerPopup.setPosition(undefined);
      }
    },
    getHighlightStyle() {
      const baseStyle = this.selectedCustomerLayer.getStyle().at(-1);
      const baseColor = baseStyle.getStroke().getColor(); // Colore originale del layer
      const baseWidth = baseStyle.getStroke().getWidth(); // Spessore originale del layer

      return [new Style({
        image: new Circle({
          radius: baseWidth + 5,
          fill: new Fill({ color: baseColor }),
          stroke: new Stroke({ color: baseColor, width: 2 })
        })
      }),
      new Style({
        stroke: new Stroke({
          color: baseColor,
          width: baseWidth + 5
        })
      })];
    },
    buildFeaturePopupHtml(feature) {
      const properties = feature.getProperties();
      const layerName = this.selectedCustomerLayer?.get('layer_name') || 'Layer sconosciuto';
      let isFirstItem = true;
      let resultString = `<h3 class="mb-2">${layerName}</h3>`;

      resultString += Object.keys(properties)
        .filter(item => item !== 'geometry')
        .map(item => {
          const result = (isFirstItem ? '' : '<br />') + `<span><b>${item}:</b> ${properties[item]}</span>`;
          isFirstItem = false;

          return result;
        })
        .join('');

      return `
        <style>
          .overlay-style {
            color: white;
            font: 12px Open Sans;
            padding: 5px 10px;
            background-color: rgba(0, 0, 0, 0.7);
            border: 1px solid green;
            border-radius: 5px;
            z-index: 100;
            max-height: 500px;
            max-width: 300px;
            overflow-y: auto;
          }
        </style>
        <div class="overlay-style">${resultString}</div>`;
    },
    openGlobalLayerPopup(feature) {
      if (!this.map?.globalLayerPopup || !this.map.globalLayerPopup.getElement()) {
        return;
      }

      this.clearSelectedFeatureHighlight();

      const coordinate = getFeaturePosition(feature);

      if (!coordinate) {
        return;
      }

      const highlightStyle = this.getHighlightStyle();
      feature.setStyle(highlightStyle);
      this.selectedHighlightedFeature = feature;

      this.map.globalLayerPopup.setPosition(coordinate);
      this.map.globalLayerPopup.getElement().innerHTML = this.buildFeaturePopupHtml(feature);
      this.map.globalLayerPopup.getElement().style.display = 'block';
      this.map.OLmap.getView().setCenter(coordinate);
      this.map.OLmap.getView().setZoom(12);
    },
    handleMapClick(event) {
      if (!this.selectedHighlightedFeature || !this.map?.OLmap) {
        return;
      }

      let clickedSameFeature = false;
      this.map.OLmap.forEachFeatureAtPixel(event.pixel, (feature) => {
        if (feature === this.selectedHighlightedFeature) {
          clickedSameFeature = true;
        }

        return false;
      });

      if (!clickedSameFeature) {
        this.clearSelectedFeatureHighlight();
      }
    },
    findAllFeatures() {
      const features = this.selectedCustomerLayer.getSource().getFeatures();
      this.findedFeatures = features.filter(f => {
        const position = getFeaturePosition(f);
        const filterValidPositionFeature = !isNaN(position[0]) && !isNaN(position[1]);

        return (f.get(this.selectedCustomerLayerProperty) === this.selectedCustomerLayerPropertyValue) && filterValidPositionFeature;
      });

      this.moveToSelectedFeature(0);
    },
    moveToSelectedFeature(index) {
      const feature = this.findedFeatures[index];

      if (!feature) {
        return;
      }

      this.selectedFeatureIndex = index;
      this.openGlobalLayerPopup(feature);
    },
    prevFeature() {
      if (this.selectedFeatureIndex > 0) {
        this.moveToSelectedFeature(this.selectedFeatureIndex - 1);
      } else {
        this.moveToSelectedFeature(this.findedFeatures.length - 1);
      }
    },
    nextFeature() {
      if (this.selectedFeatureIndex < this.findedFeatures.length - 1) {
        this.moveToSelectedFeature(this.selectedFeatureIndex + 1);
      } else {
        this.moveToSelectedFeature(0);
      }
    },
    showError() {
      return !this.isSelectVoid(this.selectedCustomerLayer) &&
        (this.customerLayerProperties.length <= 0 ||
          (!this.isSelectVoid(this.selectedCustomerLayerProperty) && this.customerLayerPropertyValues.length <= 0)
        );
    }
  }
};
</script>

<style scoped>
::v-deep .v-dialog.v-dialog--active {
  max-height: calc(100% - 56px)!important;
  margin-top: 8px!important;
}
.v-dialog__content {
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 125px;
}

@media (max-device-width:599px), (max-device-height:599px) and (orientation: landscape){
  .v-dialog__content {
     padding-left: 0px;
     justify-content: center;
  }
  ::v-deep .v-dialog.v-dialog--active {
    max-height: calc(100% - 48px)!important;
  }
}
.v-btn {
  text-transform: none;
}
.v-card {
  background-color: black;
  color: white;
  padding: 10px;
}
.search-location {
  font-size:16px;
  color: black;
  background-color: white;
  width: 88%;
  height: 48px;
  border: 0;
}
.search-location:focus {
  outline: none;
}
.inputDiv {
  background-color: white;
  border-radius: 5px;
}
</style>

<style module>
  .v-dialog--active {
    max-height: calc(100% - 48px)!important;
    margin-top: 8px!important;
  }
</style>
